import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WithSubscription } from '@shared/base';
import { Column, GridDataSource, GridQuery, SortDirection } from '@shared/models';
import { filter } from 'rxjs/operators';
import { SearchInputComponent } from '../search-input/search-input.component';
import { GridColumnValue } from './grid-header-cell/grid-header-cell.component';

@Component({
  selector: 'gcc-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
  standalone: false
})
export class GridComponent extends WithSubscription() implements OnInit {
  @Input() public dataSource: GridDataSource;
  @Input() public trackByProp: string;
  @Input() public searchInput: SearchInputComponent;

  @Output() public rowClick = new EventEmitter();

  public get queryParams(): GridQuery {
    return this._queryParams;
  }
  public set queryParams(value: GridQuery) {
    this._queryParams = value;
    this.loadData();
  }
  public pageSizeOptions = [10, 20, 40];
  public sortDirections = SortDirection;

  public isLoading: boolean;
  public totalCount: number;
  public items: Record<string, any>[] = [];

  private _queryParams: GridQuery;
  constructor() {
    super();
  }

  public ngOnInit(): void {
    this.queryParams = Object.assign(this.dataSource.defaultParameters);
    this.dataSource.reload = () => this.loadData();

    if (this.searchInput) {
      this.subs.add(
        this.searchInput.valueChange
          .asObservable()
          .pipe(filter(val => val.length >= 2 || !val.length))
          .subscribe(val => {
            this.queryParams = {
              ...this.queryParams,
              searchText: val.trim(),
              pageNumber: 1
            };
          })
      );
    }
  }

  public onRowClick(e: MouseEvent, item: Record<string, any>) {
    e.preventDefault();
    this.rowClick.emit(item);
  }

  public trackByItems(_: number, item: Record<string, any>) {
    return this.trackByProp ? item[this.trackByProp] : _;
  }

  public trackByColumns(_: number, column: Column.GridColumn) {
    return column.name;
  }

  public onPageChange($event: { page: number; itemsPerPage: number }) {
    this.queryParams = {
      ...this.queryParams,
      pageNumber: $event.page
    };
  }

  public onPageSizeChange(size: number) {
    this.queryParams = {
      ...this.queryParams,
      pageSize: size,
      pageNumber: 1
    };
  }

  // tslint:disable-next-line: no-shadowed-variable
  public onApply(columnName: string, { sortBy, sortDirection, filter }: GridColumnValue) {
    const filters = { ...this.queryParams.filters };
    if (filter && filter.length) {
      filters[columnName] = filter;
    } else {
      delete filters[columnName];
    }
    this.queryParams = {
      ...this.queryParams,
      sortBy,
      descending: sortDirection === SortDirection.Descending,
      filters,
      pageNumber: 1
    };
  }

  private loadData() {
    this.isLoading = true;
    const params = { ...this.queryParams };
    this.dataSource.query(params).subscribe(data => {
      setTimeout(() => {
        this.isLoading = false;
      }, 100);
      this.totalCount = data.totalCount;
      this.items = data.items;
    });
  }
}
